import { motion } from "framer-motion";
import YearSelect from "./YearSelect";
import { formatCount, metricValue } from "./dashboardData";

export default function ClaimsOverview({ year, setYear, data, loading }) {
  const caption = loading ? "Loading..." : `For ${year}`;
  const cards = [
    { title: "Total claims filed", value: metricValue(data?.total_filed) },
    { title: "Claims Approved", value: metricValue(data?.approved) },
    { title: "Claims Rejected", value: metricValue(data?.rejected) },
    { title: "Claims under Review", value: metricValue(data?.under_review) },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 1.1 }}
      className="mt-8"
    >
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-xl font-bold text-gray-800">Claims Overview</h2>
        <YearSelect
          year={year}
          onChange={setYear}
          className="border-green-300 focus:border-green-400 focus:ring-green-200"
        />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {cards.map((card, index) => (
          <motion.div
            key={card.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.2 + index * 0.1 }}
            className="rounded-lg border border-gray-100 bg-white p-6 shadow-sm transition-shadow duration-200 hover:shadow-md"
          >
            <h3 className="mb-3 text-sm font-medium text-gray-600">{card.title}</h3>
            <div className="text-2xl font-bold text-gray-800">
              {loading ? "..." : formatCount(card.value)}
            </div>
            <p className="mt-2 text-xs text-gray-400">{caption}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
